import React, { useEffect, useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Form,
  Label,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useHistory } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { CSVLink } from "react-csv";
import { URLS } from "../../Url";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";

const Staff = () => {
  const [users, setUsers] = useState([]);
  const [userInCsv, setUserInCsv] = useState([]);
  const [form, setForm] = useState({});
  const [filter, setFilter] = useState(false);
  const [filters, setFilters] = useState({ fromDate: "", toDate: "" });
  const [pageNumber, setPageNumber] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [listPerPage] = useState(10);
  const [completedCount, setCompletedCount] = useState(0);

  const history = useHistory();
  const gets = localStorage.getItem("authUser");
  const data = JSON.parse(gets);
  const token = data.token;
  const Roles = data?.rolesAndPermission[0];

  const cancelTokenRef = useRef(null);
  const searchTimeout = useRef(null);

  // Navigate to view booking
  const Actinid1 = (data) => {
    sessionStorage.setItem("BookingId", data._id);
    history.push("/ViewBooking");
  };

  // Fetch completed bookings with pagination & filters
  const Get = async (page = 1, search = "", filtersData = null) => {
    try {
      if (cancelTokenRef.current) cancelTokenRef.current.cancel("Canceled due to new request");
      cancelTokenRef.current = axios.CancelToken.source();

      const body = {
        page,
        limit: listPerPage,
        searchQuery: search,
        ...filtersData,
      };
      const res = await axios.post(URLS.GetCompleatedBookings, body, {
        headers: { Authorization: `Bearer ${token}` },
        cancelToken: cancelTokenRef.current.token,
      });
      if (res.data.success) {
        setUsers(res.data.data);
        // Ensure userInCsv is always a valid array
        setUserInCsv(Array.isArray(res.data.completedBookingExcel) ? res.data.completedBookingExcel : []);
        setPageCount(res.data.totalPages);
      }
    } catch (err) {
      if (axios.isCancel(err)) return;
      console.error(err);
      toast.error("Error fetching completed bookings");
    }
  };

  // Initial load
  useEffect(() => {
    Get(pageNumber);
    fetchCompletedCount();
  }, []);

  // Fetch completed bookings count
  const fetchCompletedCount = async () => {
    try {
      const response = await axios.post(
        "https://api.carnivalcastle.com/v1/carnivalApi/admin/booking/getallcompletedbookingscount",
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.success) {
        setCompletedCount(response.data.count);
      }
    } catch (error) {
      console.error("Error fetching completed booking count:", error);
    }
  };

  // Search handler with debounce
  const custsearch = (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, search: value }));
    setPageNumber(1);

    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      Get(1, value, filters.fromDate ? filters : null);
    }, 300);
  };

  // Filter handlers
  const handleChangeFlt = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const getFilter = (e) => {
    e.preventDefault();
    const filterData = { fromDate: filters.fromDate, toDate: filters.toDate };
    setPageNumber(1);
    Get(1, form.search || "", filterData);
    setFilter(false);
  };

  const hideFilter = () => setFilter(false);

  // Pagination handler
  const changePage = ({ selected }) => {
    const newPage = selected + 1;
    setPageNumber(newPage);
    Get(newPage, form.search || "", filters.fromDate ? filters : null);
  };

  // Alternative CSV data using current table data - Updated with Plan Name
  const getCSVData = () => {
    if (users.length === 0) return [];
    
    return users.map((elt, i) => ({
      "S.No": i + 1 + (pageNumber - 1) * listPerPage,
      "Event Id": elt.orderId || "",
      "Booking Date": elt.logCreatedDate?.slice(0, 10) || "",
      "Event Date": elt.date || "",
      "Event Time": elt.time || "",
      "Name": elt.userName || "",
      "Phone": elt.userPhone || "",
      "Theater Name": elt.theatreName || "",
      "Plan Name": elt.planName || "Basic Plan",
      "Occasion Name": elt.occasionName || "",
      "Remaining Price": (parseFloat(elt.totalPrice || 0) - parseFloat(elt?.advancePayment || 0)).toFixed(2),
      "Status": elt.status || ""
    }));
  };

  const alternativeCsvReport = {
    filename: "Booking_Report.csv",
    data: getCSVData(),
    headers: [
      { label: "S.No", key: "S.No" },
      { label: "Event Id", key: "Event Id" },
      { label: "Booking Date", key: "Booking Date" },
      { label: "Event Date", key: "Event Date" },
      { label: "Event Time", key: "Event Time" },
      { label: "Name", key: "Name" },
      { label: "Phone", key: "Phone" },
      { label: "Theater Name", key: "Theater Name" },
      { label: "Plan Name", key: "Plan Name" },
      { label: "Occasion Name", key: "Occasion Name" },
      { label: "Remaining Price", key: "Remaining Price" },
      { label: "Status", key: "Status" }
    ]
  };

  const exportPDF = () => {
    const unit = "pt";
    const size = "A2";
    const orientation = "portrait";
    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(15);
    
    const title = "Completed Bookings Report";
    doc.text(title, 40, 40);
    
    const headers = [
      ["S.No", "Event Id", "Event Date", "Event Time", "Name", "Phone", "Theater Name", "Plan Name", "Occasion Name", "Remaining Price", "Status"]
    ];
    
    const dataPDF = users.map((elt, i) => [
      i + 1 + (pageNumber - 1) * listPerPage,
      elt.orderId || "",
      elt.date || "",
      elt.time || "",
      elt.userName || "",
      elt.userPhone || "",
      elt.theatreName || "",
      elt.planName || "N/A",
      elt.occasionName || "",
      (parseFloat(elt.totalPrice || 0) - parseFloat(elt?.advancePayment || 0)).toFixed(2),
      elt.status || ""
    ]);
    
    doc.autoTable({
      startY: 50,
      head: headers,
      body: dataPDF,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [41, 128, 185] }
    });
    
    doc.save("Completed_Bookings_Report.pdf");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Carnival Castle Admin" breadcrumbItem="Completed Bookings" />
          <div className="mt-2 text-muted fs-5">Total Completed Bookings: {completedCount}</div>

          {filter && (
            <Card>
              <CardBody>
                <Form onSubmit={getFilter}>
                  <Row>
                    <Col lg="3">
                      <Label>From Date <span className="text-danger">*</span></Label>
                      <Input 
                        type="date" 
                        required 
                        name="fromDate" 
                        value={filters.fromDate} 
                        onChange={handleChangeFlt} 
                      />
                    </Col>
                    <Col lg="3">
                      <Label>To Date <span className="text-danger">*</span></Label>
                      <Input 
                        type="date" 
                        required 
                        name="toDate" 
                        value={filters.toDate} 
                        onChange={handleChangeFlt} 
                      />
                    </Col>
                    <Col lg="3" className="mt-4">
                      <Button type="submit" className="m-1" color="info">Search</Button>
                      <Button onClick={hideFilter} className="m-1" color="danger">Cancel</Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          )}

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      {/* Use alternative CSV report which is guaranteed to have proper format */}
                      <CSVLink {...alternativeCsvReport}>
                        <Button className="me-2" color="success">
                          <i className="fas fa-file-excel"></i> Excel
                        </Button>
                      </CSVLink>
                      <Button className="me-2" color="danger" onClick={exportPDF}>
                        <i className="fas fa-file-pdf"></i> PDF
                      </Button>
                      <Button className="me-2" color="info" onClick={() => setFilter(!filter)}>
                        <i className="fas fa-filter"></i> Filter
                      </Button>
                    </Col>
                    <Col>
                      <Input
                        name="search"
                        value={form.search || ""}
                        onChange={custsearch}
                        type="search"
                        placeholder="Search..."
                        style={{ float: "right" }}
                      />
                    </Col>
                  </Row>

                  <div className="table-responsive mt-3">
                    <Table hover bordered responsive>
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Event Id</th>
                          <th>Booking Date</th>
                          <th>Event Date</th>
                          <th>Event Time</th>
                          <th>Name</th>
                          <th>Phone</th>
                          <th>Theater Name</th>
                          <th>Plan Name</th>
                          <th>Occasion Name</th>
                          <th>Remaining Price</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users.length > 0 ? (
                          users.map((data, key) => (
                            <tr key={key}>
                              <th scope="row">{(pageNumber - 1) * listPerPage + key + 1}</th>
                              <td>{data.orderId}</td>
                              <td>{data.logCreatedDate?.slice(0, 10)}</td>
                              <td>{data.date}</td>
                              <td>{data.time}</td>
                              <td>{data.userName}</td>
                              <td>{data.userPhone}</td>
                              <td>{data.theatreName}</td>
                              <td>{data.planName || "Basic Plan"}</td>
                              <td>{data.occasionName}</td>
                              <td>{(parseFloat(data.totalPrice || 0) - parseFloat(data?.advancePayment || 0)).toFixed(2)}</td>
                              <td>{data.status}</td>
                              <td>
                                {(Roles?.compeletedBookingsView || Roles?.accessAll) && (
                                  <Button 
                                    onClick={() => Actinid1(data)} 
                                    size="sm" 
                                    className="m-1" 
                                    color="info"
                                  >
                                    <i className="fas fa-eye px-1"></i> View
                                  </Button>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="13" className="text-center">
                              No completed bookings found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>

                    {pageCount > 1 && (
                      <div className="d-flex justify-content-end mt-3">
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                          activeClassName={"active"}
                          forcePage={pageNumber - 1}
                        />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </div>
    </React.Fragment>
  );
};

export default Staff;